import request from "../utils/request"

export function fetchSquareTagOverview() {
  return request({
    url: "/admin/square-tags/overview",
    method: "get"
  })
}

export function fetchSquareTags(params = {}) {
  return request({
    url: "/admin/square-tags",
    method: "get",
    params
  })
}

export function updateSquareTagStatus(normalizedName, status) {
  return request({
    url: "/admin/square-tags/status",
    method: "post",
    params: { normalizedName, status }
  })
}

export function updateSquareTagDisplayName(normalizedName, displayName) {
  return request({
    url: "/admin/square-tags/display-name",
    method: "post",
    params: { normalizedName, displayName }
  })
}

export function mergeSquareTags(source, target) {
  return request({
    url: "/admin/square-tags/merge",
    method: "post",
    params: { source, target }
  })
}

export function rebuildSquareTagIndexes() {
  return request({
    url: "/admin/square-tags/rebuild",
    method: "post"
  })
}
